module.exports = __webpack_public_path__ + "static/media/ad-demo.3b66e422.mp4";